// extracted by mini-css-extract-plugin
export default {"grid":"ingredients-grid_grid__XlIg3"};